import overrides from './formatOverrides'
import { currencyChanged } from '../../redux/actions'

let store
let formatters = {}
let currency
let locale
let notFun
let supportsIntl
let currencySign
let isunFormatable
const currencySignRegExp = new RegExp(/(0)|(\s)/, 'g')

const defaultProperties = {
  style: 'currency',
  currencyDisplay: 'symbol',
  showCurrency: true,
  useSeparators: false,
  showSubUnits: false
}

const getFormatId = function(config) {
  let id = 0
  const { maximumFractionDigits, useGrouping, style } = config
  if (maximumFractionDigits) {
    id += 2
  }
  if (useGrouping) {
    id += 4
  }
  if (style === 'decimal') {
    id += 8
  }
  return id
}


const getFormatter = function(config) {
  const formatId = getFormatId(config)
  if (!formatters[formatId]) {
    formatters[formatId] = Intl.NumberFormat(locale, config)
  }
  return formatters[formatId]
}

function getConfig(value, properties) {
  const showCurrency = notFun && properties.showCurrency
  const trailingZeroes = (value % 100) === 0
  const useGrouping = properties.useSeparators
  const maximumFractionDigits = (properties.showSubUnits || !trailingZeroes) ? 2 : 0
  const minimumFractionDigits = maximumFractionDigits
  const style = showCurrency ? 'currency' : 'decimal'

  return {
    maximumFractionDigits,
    minimumFractionDigits,
    useGrouping,
    style,
    currency
  }
}

/**
 * Sets the internal reference to the store being used to format currencies
 * @param {*} s - The store to use
 */
function setStore(s) {
  if (!s) { return }

  store = s
}
 /**
  * Initialize the currency-formatter, needs to be called after every login.
  */
function init() {
  if (!store) {
    return
  }
  const { session } = store.getState()
  currency = session.currency
  const _overrides = overrides[currency]
  locale = session.locale.replace('_', '-').toLowerCase()

  if (_overrides) {
    locale = _overrides.indexOf(locale) >= 0 ? locale : _overrides[0]
  }

  notFun = session.currency !== 'FUN'

  supportsIntl = false
  if (Intl && Intl.NumberFormat) {
    try {
      const config = getConfig(100, defaultProperties)
      const formatter = Intl.NumberFormat(locale, config)
      supportsIntl = !!formatter.format
    } catch (e) { }
  }

  try {
    const tempValue = format(0)
    currencySign = notFun ? tempValue.replace(currencySignRegExp, '') : 'FUN'
    isunFormatable = false
  } catch (e) {
    isunFormatable = true
    currencySign =  currency
  }

  formatters = {}
  store.dispatch(currencyChanged(currency, currencySign))
}

/**
 * Returns the default properies of the currency-formatter.
 */
function getDefaultProperties() {
  return defaultProperties
}

/**
* Function used to format a currency.
*
* @param {number} value The value that should be formatted.
* @param {object} properties contains information on how the formatting should be performed.
* Supports the following properties: showCurrency, useSeparators, showSubUnits
*/
export function format(value, props = defaultProperties) {
  const properties = { ...defaultProperties, ...props }
  const config = getConfig(value, properties)
  const transformedValue = value / 100

  if (isunFormatable) {
    return transformedValue.toFixed(config.minimumFractionDigits)
  }

  if (supportsIntl) {
    return getFormatter(config).format(transformedValue)
  }

  return transformedValue.toLocaleString(locale, config)
}

const Currency = {
  setStore,
  init,
  getDefaultProperties,
  format
}

export default Currency
